var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analystics_paga"},[_c('h3',{staticClass:"title-page"},[_vm._v(" "+_vm._s(_vm.$t("analytics"))+" ")]),_c('chart-warehouse',{attrs:{"params":_vm.filter}}),_c('div',[_c('GeolacationPicker',{attrs:{"w":'500',"h":'500'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }